"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Asimov = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Awards_1 = require("../../awards/Awards");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectOption_1 = require("../../inputs/SelectOption");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const Size_1 = require("../render/Size");
const Dealer_1 = require("../../Dealer");
const constants_1 = require("../../constants");
class Asimov extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.ASIMOV,
            cardType: CardType_1.CardType.LEADER,
            metadata: {
                cardNumber: 'L01',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br.br;
                    b.award().nbsp().colon().text(`+${constants_1.ASIMOV_AWARD_BONUS}`, Size_1.Size.LARGE);
                    b.br.br.br;
                    b.opgArrow().text('10-X').award().asterix();
                }),
                description: `You have +${constants_1.ASIMOV_AWARD_BONUS} score for all awards. Once per game, draw 10-X awards (min. 1), where X is the current generation number. You may put one into the game and fund it for free.`,
            },
        });
        this.isDisabled = false;
    }
    play() {
        return undefined;
    }
    canAct(player) {
        return !player.game.allAwardsFunded() && this.isDisabled === false;
    }
    action(player) {
        const game = player.game;
        const awardCount = Math.max(1, 10 - game.generation);
        let availableAwards = Awards_1.ALL_AWARDS.filter((award) => {
            if (game.awards.includes(award))
                return false;
            if (!game.gameOptions.venusNextExtension && award.name === 'Venuphile')
                return false;
            if (!game.gameOptions.turmoilExtension && award.name === 'Politician')
                return false;
            if (!game.gameOptions.aresExtension && award.name === 'Entrepreneur')
                return false;
            if (!game.gameOptions.aresExtension && award.name === 'Rugged')
                return false;
            if (!game.gameOptions.moonExpansion) {
                if (Awards_1.MOON_AWARDS.includes(award))
                    return false;
            }
            if (!game.gameOptions.newOpsExpansion) {
                if (Awards_1.NEW_OPS_AWARDS.includes(award))
                    return false;
            }
            if (!game.gameOptions.preludeTwoExtension) {
                if (Awards_1.PRELUDE_TWO_AWARDS.includes(award))
                    return false;
            }
            return true;
        });
        const freeAward = new OrOptions_1.OrOptions();
        freeAward.title = 'Select award to put into play and fund';
        freeAward.buttonLabel = 'Confirm';
        availableAwards = Dealer_1.Dealer.shuffle(availableAwards);
        freeAward.options = availableAwards.slice(0, awardCount).map((award) => this.selectAwardToFund(player, award));
        freeAward.options.push(new SelectOption_1.SelectOption('Do nothing', 'Confirm', () => {
            game.log('${0} chose not to fund any award', (b) => b.player(player));
            this.isDisabled = true;
            return undefined;
        }));
        return freeAward;
    }
    selectAwardToFund(player, award) {
        let title = 'Fund ' + award.name + ' award' + ' [';
        title += player.game.getPlayers()
            .sort((a, b) => award.getScore(b) - award.getScore(a))
            .map((player) => player.name + ': ' + award.getScore(player)).join(' / ') + ']';
        return new SelectOption_1.SelectOption(title, 'Confirm', () => {
            player.game.awards.push(award);
            player.game.fundAward(player, award);
            this.isDisabled = true;
            return undefined;
        });
    }
}
exports.Asimov = Asimov;
//# sourceMappingURL=Asimov.js.map